'use client';

import { useEffect } from 'react';
// Side-effect import: initializes the install-prompt capture bridge on EVERY
// route (this component is mounted in the root layout <body>), not just the
// authenticated shell — so a beforeinstallprompt fired on the login page is
// still observed. See installPromptStore.ts.
import './installPromptStore';

/**
 * Registers the (no-op, zero-caching) service worker at `/sw.js`. Its only
 * purpose is to satisfy Chrome's installability criteria; it caches nothing, so
 * there's no stale-content or per-user-data-leak risk. Registration is
 * fire-and-forget — the SW is non-critical, so failures are swallowed. Mounted
 * once in the root layout; renders nothing.
 */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    // `updateViaCache: 'none'` forces the browser to revalidate sw.js on every
    // update check, so a future SW change propagates without HTTP-cache lag.
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {
      /* installability is a progressive enhancement — ignore registration errors */
    });
  }, []);

  return null;
}
